import type { Contact } from '../../types/db';

export const contacts: Contact[] = [
  {
    id: 'lisa',
    name: 'Lisa',
    role: 'nieuwe klant',
    company: 'Studio Veld',
    about: ['Studio Veld, ontwerpbureau in Utrecht', '12 medewerkers, groeit snel', 'Zoekt hulp bij een klantportaal'],
    openQuestion: 'Budget en planning zijn nog niet besproken.',
  },
  {
    id: 'bakker',
    name: 'klant Bakker',
    role: 'vaste klant',
    company: 'Bakker Installaties',
    about: ['Installatiebedrijf, klant sinds 2024', 'Loopt: onderhoudscontract website'],
  },
];
